import React from 'react';
import { Bluetooth, Signal, Wifi } from 'lucide-react';
import { Card } from '../ui/Card';
import { SectionHeading } from '../ui/SectionHeading';
export function ControlModes() {
  return <section className="py-24 bg-[#0a0a0f]" data-id="element-80">
      <div className="container mx-auto px-4 md:px-6" data-id="element-81">
        <SectionHeading title="Bluetooth & 4G – Zwei Steuerungsmodi" subtitle="Maximale Flexibilität und Zuverlässigkeit in jeder Situation." align="center" data-id="element-82" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-83">
          {/* Bluetooth */}
          <Card className="relative overflow-hidden group" data-id="element-84">
            <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-85">
              <Bluetooth className="w-32 h-32 text-blue-500" data-id="element-86" />
            </div>
            <div className="relative z-10" data-id="element-87">
              <div className="w-14 h-14 bg-blue-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-88">
                <Bluetooth className="w-7 h-7 text-blue-400" data-id="element-89" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-90">
                Bluetooth (BLE) – Nahbereich
              </h3>
              <ul className="space-y-3 text-gray-300" data-id="element-91">
                <li className="flex items-center gap-2" data-id="element-92">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full" data-id="element-93" />
                  Extrem schnelle Reaktionszeit (&lt; 200ms)
                </li>
                <li className="flex items-center gap-2" data-id="element-94">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full" data-id="element-95" />
                  Funktioniert komplett offline (ohne Netz)
                </li>
                <li className="flex items-center gap-2" data-id="element-96">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full" data-id="element-97" />
                  Ideal für tägliches Öffnen & Starten
                </li>
                <li className="flex items-center gap-2" data-id="element-98">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full" data-id="element-99" />
                  Smart Access (Auto-Unlock)
                </li>
              </ul>
            </div>
          </Card>

          {/* 4G */}
          <Card className="relative overflow-hidden group" data-id="element-100">
            <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-101">
              <Signal className="w-32 h-32 text-cyan-500" data-id="element-102" />
            </div>
            <div className="relative z-10" data-id="element-103">
              <div className="w-14 h-14 bg-cyan-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-104">
                <Signal className="w-7 h-7 text-cyan-400" data-id="element-105" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-106">
                4G Remote – Fernsteuerung
              </h3>
              <ul className="space-y-3 text-gray-300" data-id="element-107">
                <li className="flex items-center gap-2" data-id="element-108">
                  <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full" data-id="element-109" />
                  Steuerung aus beliebiger Entfernung
                </li>
                <li className="flex items-center gap-2" data-id="element-110">
                  <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full" data-id="element-111" />
                  Ideal für Vorheizen & Vorkühlen
                </li>
                <li className="flex items-center gap-2" data-id="element-112">
                  <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full" data-id="element-113" />
                  Standortabfrage & Statuscheck
                </li>
                <li className="flex items-center gap-2" data-id="element-114">
                  <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full" data-id="element-115" />
                  Perfekt für Flotten & Car Sharing
                </li>
              </ul>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}